import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { Breadcrumb, BreadcrumbNav } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-location-details-breadcrumb-nav',
  imports: [BreadcrumbNav, Breadcrumb, RouterLink, NgIcon, TranslocoPipe],
  templateUrl: './location-details-breadcrumb-nav.html',
})
export class LocationDetailsBreadcrumbNav {
  organizationId = input.required<string>();
  locationId = input.required<string>();
}
